// frontend/src/pages/HomePage.jsx
import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function HomePage() {
  const { isAdmin, authenticated } = useAuth();

  return (
    <>
      {/* 🌌 Background Video Loop */}
      <video autoPlay loop muted playsInline
        style={{
          position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
          objectFit: "cover", zIndex: -2, filter: "brightness(0.6) contrast(1.2)"
        }}>
        <source src="/assets/quantum-loop.mp4" type="video/mp4" />
      </video>

      {/* 🌑 Overlay Dark Layer (Readability) */}
      <div style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: -1,
        background: "rgba(0, 0, 0, 0.6)"
      }}></div>

      {/* 🚀 Main Content (Relative, z-index 1) */}
      <div style={{
        position: "relative",
        zIndex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "80vh",
        gap: "40px",
        textAlign: "center"
      }}>

        <h1 style={{
          fontSize: "2.5rem",
          background: "linear-gradient(90deg, #a575eb, #00f260)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          marginBottom: "20px"
        }}>
          Oracle d'Entropie Quantique
        </h1>

        {/* Ligne 1 : Les outils principaux */}
        <div style={{ display: "flex", gap: "20px", flexWrap: "wrap", justifyContent: "center" }}>
          <Link to="/token-generator-dashboard" style={btnStyle}>🎲 Générateur Token</Link>
          <Link to="/entropy-dashboard" style={btnStyle}>⚡ Entropy Dashboard</Link>
        </div>

        {/* Ligne 2 : Les nouveaux outils Business */}
        <div style={{ display: "flex", gap: "20px", flexWrap: "wrap", justifyContent: "center" }}>
          <Link to="/quid" style={{...btnStyle, border: "1px solid #0ff", color: "#0ff", background: "rgba(0, 255, 255, 0.1)"}}>
            🏷️ Certification QUID
          </Link>
          <Link to="/web3-wallet" style={btnStyle}>💼 Web3 Wallet</Link>
          <Link to="/governance" style={{...btnStyle, border: "1px solid #00E0FF", color: "#00E0FF", background: "rgba(0, 224, 255, 0.1)", boxShadow: "0 4px 15px rgba(0, 224, 255, 0.3)"}}>
            🏛️ Gouvernance
          </Link>
          {/* 🚀 Portail client B2B (Phase 19) — accès public clients (≠ admin) */}
          <Link to="/portal/register" style={{...btnStyle, color: "#c9a4ff", background: "rgba(165, 117, 235, 0.12)", border: "1px solid #a575eb", boxShadow: "0 0 18px rgba(165, 117, 235, 0.55)"}}>
            🚀 Portail API / B2B
          </Link>
        </div>

        {/* Zone Admin : visible pour Admin, lien login sinon */}
        <div style={{ marginTop: "50px" }}>
          {isAdmin ? (
            <Link to="/admin" style={{
              color: "#00FF94",
              textDecoration: "none",
              fontSize: "1rem",
              padding: "10px 24px",
              border: "1px solid rgba(0,255,148,0.4)",
              borderRadius: "8px",
              background: "rgba(0,255,148,0.08)",
              boxShadow: "0 0 15px rgba(0,255,148,0.2)",
              transition: "all 0.3s"
            }}>
              🔧 Accès Super Admin (Oracle)
            </Link>
          ) : (
            <Link to="/quid" style={{
              color: "#888",
              textDecoration: "none",
              fontSize: "0.9rem",
              opacity: 0.6
            }}>
              {authenticated ? "🔒 Accès réservé Admin" : "🔑 Se connecter"}
            </Link>
          )}
        </div>

      </div>
    </>
  );
}

// Style des boutons violets (copié de ton design)
const btnStyle = {
  background: "#a575eb",
  color: "#000",
  padding: "15px 30px",
  borderRadius: "12px",
  textDecoration: "none",
  fontWeight: "bold",
  fontSize: "1.1rem",
  boxShadow: "0 4px 15px rgba(165, 117, 235, 0.4)",
  transition: "transform 0.2s",
  display: "inline-block"
};
